export default __webpack_public_path__ + "static/media/Andrzejewski.36d4d54a.png";